import { render } from "./LinkButton.vue?vue&type=template&id=3903a657&scoped=true&ts=true"
import script from "./LinkButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./LinkButton.vue?vue&type=script&lang=ts&setup=true"

import "./LinkButton.vue?vue&type=style&index=0&id=3903a657&lang=scss&scoped=true"

import exportComponent from "/builds/easy/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3903a657"],['__file',"resources/js/Components/LinkButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3903a657"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3903a657', __exports__)) {
    console.log('reload')
    api.reload('3903a657', __exports__)
  }
  
  module.hot.accept("./LinkButton.vue?vue&type=template&id=3903a657&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('3903a657', render)
  })

}


export default __exports__